export default "__VITE_ASSET__BUU6Uv1r__"